export enum ProcessoNums {
    Disponible = 0,
    Reservado = 1,
    PendientePago = 2,
    MermaRoto = 3,
    Envio = 4,
    VendidoTarjeta = 5,
    VendidoEfectivo = 6,
    Reparacion = 7,
    Devolucion = 8
}
// Método que recibe un valor de ProcessoNums y devuelve el texto correspondiente
export function getTexto(processoNum: number): string {
    switch (processoNum) {
        case ProcessoNums.Disponible:
            return "Disponible";
        case ProcessoNums.Reservado:
            return "Reservado";
        case ProcessoNums.PendientePago:
            return "PendientePago";
        case ProcessoNums.MermaRoto:
            return "MermaRoto";
        case ProcessoNums.Envio:
            return "Envio";
        case ProcessoNums.VendidoTarjeta:
            return "VendidoTarjeta";
        case ProcessoNums.VendidoEfectivo:
            return "VendidoEfectivo";
        case ProcessoNums.Reparacion:
            return "Reparacion";
        case ProcessoNums.Devolucion:
            return "Devolucion";
        default:
            return "Estado desconocido";
    }
}
// Método que recibe un texto y devuelve el número correspondiente de ProcessoNums
export function getNumero(procesoTexto: string): number {
    switch (procesoTexto) {
        case "Disponible":
            return ProcessoNums.Disponible;
        case "Reservado":
            return ProcessoNums.Reservado;
        case "PendientePago":
            return ProcessoNums.PendientePago;
        case "MermaRoto":
            return ProcessoNums.MermaRoto;
        case "Envio":
            return ProcessoNums.Envio;
        case "VendidoTarjeta":
            return ProcessoNums.VendidoTarjeta;
        case "VendidoEfectivo":
            return ProcessoNums.VendidoEfectivo;
        case "Reparacion":
            return ProcessoNums.Reparacion;
        case "Devolucion":
            return ProcessoNums.Devolucion;
        default:
            throw new Error(`El texto "${procesoTexto}" no corresponde a ningún estado válido.`);
    }
}
